import React, { useState, useEffect } from 'react';
import { Table, Button, Space, Input, Select, message, Modal, Form, AutoComplete, DatePicker, Switch, Pagination } from 'antd';
import useWebPost from '../../utils/useWebPost';
import { dayjsDate, formatDate, formatDate2, formatNumber,exportToCSV } from '../../utils/functions';
import FullHeightLayout from '../../components/FullHeightLayout';
import renderFileList from '../../components/renderFileList';
import DateSelector from '../../components/DateSelector';

const { Option } = Select;

function Gsyjb() {
    const webPost = useWebPost();
    const pageSizeOptions = [10, 20, 50, 100, 500];
    const [currentItem, setCurrentItem] = useState(null);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [total, setTotal] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(50);


    const [form] = Form.useForm();
    const [xmmc, setXmmc] = useState('');
    const [filter, setFilter] = useState({});
    const [dates, setDates] = useState({});
    const [freshData, setFreshData] = useState(0);
    useEffect(() => {
        fetchItems(currentPage);
    }, [currentPage]);
    useEffect(() => {
        fetchItems(1);
    }, [pageSize]);
    // 获取数据
    const fetchItems = async (page = 1) => {
        if (loading) return;
        setLoading(true);
        try {
            const params = {
                page: page,
                limit: pageSize,
                xm: xmmc.trim(),
                ...dates,
                ...filter
            };
            const response = await webPost('gsyjb', params);
            if (response?.data) {
                setData(response.data);
                setTotal(response.total || 0);
            }
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchItems(currentPage);
    }, [currentPage, pageSize,freshData]);

    

    const columns = [
        {
            title: '序号',
            key: 'sn',
            width: 58,
            fixed: 'left',
            render: (_, __, index) => index + 1 + (currentPage - 1) * pageSize,
        },
        { title: '年份', dataIndex: 'co_date', width: 120 },
        { title: '项目编号', dataIndex: 'sn', width: 120 },
        { 
            title: '项目名称', 
            dataIndex: 'xmmc', 
            width: 120, 
            ellipsis: { showTitle: true, } 
        },
        { title: '合同类型', dataIndex: 'co_type', width: 120, },
        { 
            title: '业主名称', 
            dataIndex: 'customer_name', 
            width: 120, 
            ellipsis: { showTitle: true, }, 
        },
        { title: '业主性质', dataIndex: 'customer_nature', width: 120, },
        { title: '所属行业/专业', dataIndex: 'zylx', width: 120, },
        { 
            title: '合同额(万元)', 
            dataIndex: 'sjamount', 
            width: 120, 
            render: (v) => formatNumber(v / 10000) 
        },
        { 
            title: '项目地点', 
            dataIndex: 'location', 
            width: 100, 
        },
        { 
            title: '项目规模', 
            dataIndex: 'xmgm', 
            width: 100, 
        },
        { 
            title: '合同范围', 
            dataIndex: 'htfw', 
            width: 100, 
        },
        { title: '中标通知书、合同', dataIndex: 'zf1', width: 120 , render:(v)=>renderFileList(v)},
        { title: '合同-1附件', dataIndex: 'htpath', width: 120, render:(v)=>renderFileList(v) },
        { title: '竣工验收单', dataIndex: 'zf3', width: 120, render:(v)=>renderFileList(v) },
        { 
            title: '备注', 
            dataIndex: 'ps', 
            width: 100, 
            ellipsis: { showTitle: true, } 
        },
    ];
    
    useEffect(() => {
        if (currentItem) {
            form.setFieldsValue({
                ...currentItem,
                rq1: currentItem.rq1 ? dayjsDate(currentItem.rq1) : null,
            });
        } else {
            form.resetFields();
        }
    }, [currentItem, form]);



    const onPageChange = (page, size) => {
        setCurrentPage(page);
        if (size !== pageSize) setPageSize(size);
    };

    return (
        <FullHeightLayout
            headerContent={
                <Space style={{ marginBottom: 16 }}>
                    <DateSelector onChange={(v)=>{setDates(v); console.log(v)}}  />
                    <Input value={xmmc} placeholder='项目名称、招标单位、客户姓名、业绩归属' style={{ width: 320 }} onChange={(e) => setXmmc(e.target.value)} allowClear />
                    <Input value={filter.ht} placeholder='合同类型、范围、所属行业/专业、项目规模' style={{ width: 320 }} 
                    onChange={(e) => setFilter(prev=>({...prev, ht:e.target.value})) } allowClear />
                    
                    <Button onClick={()=>setFreshData(Math.random())}>搜索</Button>
                    <Button onClick={()=>{exportToCSV(data,columns,'公司业绩表')}}>下载</Button>
                </Space>
            }
            bodyContent={
                <Table
                    columns={columns}
                    dataSource={data}
                    rowKey="id"
                    loading={loading}
                    size="middle"
                    bordered
                    pagination={false}
                    scroll={{ x: 1800,y: 'calc(100vh - 240px)' }}
                    tableLayout="fixed"
                    locale={{ emptyText: '暂无数据' }}
                />
            }
            footerContent={
                <Pagination
                    current={currentPage}
                    pageSize={pageSize}
                    total={total}
                    showSizeChanger
                    showQuickJumper
                    showTotal={(total, range) => `第 ${range[0]}-${range[1]} 条，共 ${total} 条`}
                    onChange={onPageChange}
                    pageSizeOptions={pageSizeOptions}
                />
            }
        />
    );
}



export default Gsyjb;